import { useQuery } from "@tanstack/react-query";
import { getGroups } from "../../../services/groupServices";
import GroupManager from "../../../components/admin/messages/GroupManager";
import SmsGroupManager from "../../../components/admin/messages/SmsGroupManager";

export default function SmsGroups() {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["groups"],
    queryFn: getGroups,
    retry: false,
  });

  if (isError) {
    return (
      <div>
        <p className="text-red-500">
          Error: {error?.message || "Failed to fetch groups"}
        </p>
        <button onClick={() => refetch()}>Retry</button>
      </div>
    );
  }

  return <SmsGroupManager users={data?.data ?? []} refreshGroups={refetch} />;
}
